import { type SizeFiltersResponse } from './aliases';
import { normaliseCompositeSizeId } from './helpers';

import { type FetchFilterAggregatesResponse } from '@/modules/search/types';

/**
 * Diagram here: https://github.com/depop/web-default-website-server/pull/291
 */
export function pruneEmptySizes(
  sizeTree: SizeFiltersResponse,
  aggregates: FetchFilterAggregatesResponse['sizes']
): SizeFiltersResponse {
  if (Object.keys(aggregates).length === 0) {
    return sizeTree;
  }

  const availableSizesSet = new Set<string>(Object.keys(aggregates));

  return sizeTree.flatMap((department) => {
    const groups = department.children.flatMap((group) => {
      const regions = group.children.flatMap((region) => {
        const sizes = region.children.filter(
          (size) =>
            normaliseCompositeSizeId(size.composite_id) &&
            availableSizesSet.has(normaliseCompositeSizeId(size.composite_id))
        );

        return sizes.length > 0 ? [{ ...region, children: sizes }] : [];
      });

      return regions.length > 0 ? [{ ...group, children: regions }] : [];
    });

    return groups.length > 0 ? [{ ...department, children: groups }] : [];
  });
}
